import { Button } from "../../../../components/ui/common/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "../../../../components/ui/common/select";

/** Same page-size choices the legacy `PaginationView` offered (src/components/pagination/Pagination.tsx). */
const PAGE_SIZE_OPTIONS = [5, 10, 20, 50];

interface CompanyListPaginationProps {
  totalCount: number;
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

/**
 * Tailwind pagination footer, copied from `ProductListPagination`: a count
 * label on the left, Previous/Next `Button`s with a "Page X of Y" label on
 * the right. Unlike Product, the legacy company grid let users pick a page
 * size, which is existing functionality — so a compact page-size `Select`
 * is kept alongside.
 */
const CompanyListPagination = ({
  totalCount,
  pageNumber,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange
}: CompanyListPaginationProps) => (
  <div className="tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
    <p className="tw-text-xs tw-text-muted-foreground">
      {totalCount} compan{totalCount !== 1 ? "ies" : "y"} found
    </p>
    <div className="tw-flex tw-items-center tw-gap-3">
      <div className="tw-flex tw-items-center tw-gap-2">
        <span className="tw-text-xs tw-text-muted-foreground">Rows per page</span>
        <Select value={String(pageSize)} onValueChange={value => onPageSizeChange(Number(value))}>
          <SelectTrigger className="!tw-h-8 tw-w-[4.5rem] tw-text-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZE_OPTIONS.map(size => (
              <SelectItem key={size} value={String(size)}>
                {size}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {totalPages > 1 ? (
        <div className="tw-flex tw-items-center tw-gap-2">
          <Button
            variant="outline"
            size="sm"
            disabled={pageNumber <= 1}
            onClick={() => onPageChange(pageNumber - 1)}
          >
            Previous
          </Button>
          <span className="tw-text-sm tw-text-muted-foreground">
            Page {pageNumber} of {totalPages}
          </span>
          <Button
            variant="outline"
            size="sm"
            disabled={pageNumber >= totalPages}
            onClick={() => onPageChange(pageNumber + 1)}
          >
            Next
          </Button>
        </div>
      ) : null}
    </div>
  </div>
);

export default CompanyListPagination;
